export const WITHOUT_LIST_ID = 'without-list'

export interface ITaskListBase {
  id: string
  name: string
  order: number
  orderOfTask?: number
  collapsed: boolean
  shown: boolean
  projectId?: string
  userId?: string
  updatedOn?: Date
  isSaving?: boolean
  isArchived?: boolean
  updatedBy: string
  createdOn?: Date
  createdBy?: Date
  isNew?: boolean
  isWithoutList?: boolean
  isHiddenForConnectUsers?: boolean
  plannedDuration?: number
  totalPlannedDuration?: number
  totalPlannedDurationWithHierarchy?: number
  trackedDuration?: number
}

export class TaskListBase implements ITaskListBase {
  id: string
  name: string
  order: number
  orderOfTask?: number
  collapsed = false
  shown = true
  projectId?: string
  userId?: string
  updatedOn?: Date
  isSaving?: boolean
  isArchived?: boolean
  updatedBy: string
  createdOn?: Date
  createdBy?: Date
  typeName = 'TaskList'
  isNew?: boolean
  isWithoutList?: boolean
  isHiddenForConnectUsers?: boolean
  plannedDuration?: number
  totalPlannedDuration?: number
  totalPlannedDurationWithHierarchy?: number
  trackedDuration?: number

  constructor(taskList: Partial<ITaskListBase>) {
    Object.assign(this, taskList)

    if (this.updatedOn) {
      this.updatedOn = new Date(this.updatedOn)
    }

    this.isNew = taskList.isNew
    this.isWithoutList = taskList.id === WITHOUT_LIST_ID || this.order === 9999
  }

  static isTaskList(list: unknown): list is TaskListBase {
    return (list as TaskListBase)?.typeName === 'TaskList'
  }
}
